import { render, staticRenderFns } from "./register-tcp.vue?vue&type=template&id=0848ab62&scoped=true&"
import script from "./register-tcp.vue?vue&type=script&lang=js&"
export * from "./register-tcp.vue?vue&type=script&lang=js&"
import style0 from "./register-tcp.vue?vue&type=style&index=0&id=0848ab62&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0848ab62",
  null
  
)

export default component.exports